import './Program_table.css';
import morningAgenda from '../../data/program/morningAgenda';

const formatEvent = (item) => {
  if (item.speaker) {
    return (
      <>
        {item.session}
        <br />
        <span className="program-speaker">{item.speaker}</span>
      </>
    );
  }
  return item.session;
};

const locationFor = (session) => {
  if (session === 'Lunch' || session === 'Lunch Break') {
    return 'Banquet Hall';
  }
  return 'Multi-function Hall';
};

const ProgramTable = () => {
  const july18RowCount = morningAgenda.length + 3; // afternoon + tea note + banquet

  return (
    <table className="program-table">
      <tbody>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Events</th>
          <th>Location</th>
        </tr>
        <tr>
          <td rowSpan="2">July 17th</td>
          <td>13:00-18:00</td>
          <td>Onsite Registration &amp; Check-in</td>
          <td>Hotel Lobby</td>
        </tr>
        <tr>
          <td>18:00-19:30</td>
          <td>Welcome Reception (Dinner)</td>
          <td>Banquet Hall</td>
        </tr>
        {morningAgenda.map((item, index) => (
          <tr key={item.time}>
            {index === 0 && (
              <td rowSpan={july18RowCount}>July 18th</td>
            )}
            <td>{item.time}</td>
            <td>{formatEvent(item)}</td>
            <td>{locationFor(item.session)}</td>
          </tr>
        ))}
        <tr>
          <td>13:00-18:40</td>
          <td className="events-multi">
            Parallel Sessions (Onsite Room)<br />
            Parallel Sessions (Online Room 1)<br />
            Parallel Sessions (Online Room 2)
          </td>
          <td className="events-multi">
            Onsite Room<br />
            Online Room 1<br />
            Online Room 2
          </td>
        </tr>
        <tr>
          <td>—</td>
          <td>
            Tea Breaks: Onsite 16:00–16:20; Online 14:40–15:00 / 14:40–15:20
          </td>
          <td>-</td>
        </tr>
        <tr>
          <td>18:30-20:30</td>
          <td>Banquet</td>
          <td>Banquet Hall</td>
        </tr>
        <tr>
          <td>July 19th-20th</td>
          <td>-</td>
          <td>Social Activities after technical sessions</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ProgramTable;
